<template>
    <div >
      <div class="card-group justify-content-center m-auto " >
        <div class="cardContainer col p-0 " @click="goTodetail(servizio.id)"
         v-for="servizio in servizi"
          :key="servizio.id">
         <card-servizio   :servizio="servizio" /></div>
      </div>
    </div>
</template>

<script>

import ServiziDataService from '@/service/ServiziDataService.js'
import cardServizio from './card-servizio.vue'

export default {
  name: 'servizi-list',
  components: { cardServizio },
  data () {
    return {
      comune: this.$store.getters.getComune.codiceCatasto,
      servizi: []
    }
  },
  methods: {
    caricaServizi (idSer) {
      return ServiziDataService
        .getServiziByCommuneId(idSer)
        .then(response => {
          console.log(response.data)
          return response.data
        })
        .catch(e => {
          console.log(e)
          return []
        })
    },
    goTodetail (servId) {
      this.$store.dispatch('caricaInfoServizio', servId)
      this.$router.push({ name: 'About', params: { Sid: servId } })
    }
  },
  mounted () {
    this.caricaServizi(this.comune).then(risultato => {
      console.log(risultato)
      this.servizi = risultato
    })
  },
  computed: {
    comuneC () { return this.$store.getters.getComune.codiceCatasto }
  },
  watch: {
    comuneC: function (New, Old) {
      console.log('OLD -->', Old)
      console.log('NEW -->', New)
      if (New) {
        this.caricaServizi(New).then(risultato => {
          this.servizi = risultato
        })
      }
    }
  }
}
</script>
